import { render } from "./HomeView.vue?vue&type=template&id=983c9d32"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import exportComponent from "/home/utrady.com/app_source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__